import request from '@/utils/request'

const url_prefix = process.env.VUE_APP_API_URL

export function upload({ file }) {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  return request(
    {
      url: `${url_prefix}/backend-api/assistant/file_upload`,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData,
      timeout: 60000
    },
    {
      loading: false,
      repeatRequestCancel: false
    }
  )
}

export function getRepaintImage(data, signal) {
  return request(
    {
      url: `${url_prefix}/backend-api/v1/model_proxy/inpainting`,
      method: 'post',
      data,
      signal,
      timeout: 60000
    },
    {
      loading: false
    }
  )
}
